import React from 'react';
import PropTypes from 'prop-types';
import { UncontrolledTooltip } from 'reactstrap';

import { getFormattedDateTime } from '../helpers/DateTime';
import {
  getSetting,
  getUserSetting,
} from '../helpers/Settings';

const DateTimeTooltip = ({ dateTime, target }) => {
  if (!(getUserSetting('relative_date_time') || getSetting('relative_date_time'))) {
    return null;
  }

  return (
    <UncontrolledTooltip placement="bottom" target={target} fade={false}>
      {getFormattedDateTime(dateTime, true)}
    </UncontrolledTooltip>
  );
};

DateTimeTooltip.propTypes = {
  dateTime: PropTypes.string.isRequired,
  target: PropTypes.string.isRequired,
};

export default DateTimeTooltip;
